<template>
  <div class="cascade-course-select">
    <div class="report__choise">
      <label class="report__input-label">
        {{ $t('mc.mimk.mcReport.courseDirection') || 'Курс - направление' }}
      </label>
      <v-select
        v-model="selectedCourseGlobal"
        :options="courseGlobalOptions"
        :clearable="true"
        :searchable="false"
        :loading="loadingGlobal"
        :placeholder="$t('mc.mimk.mcReport.placeholder.donotChoise')"
        label="label"
        value="value"
        class="report__select"
        @input="handleCourseGlobalChange"
      />
    </div>

    <div v-if="selectedCourseGlobal" class="report__choise">
      <label class="report__input-label">
        {{ $t('mc.mimk.mcReport.courseType') || 'Курс - тип' }}
      </label>
      <v-select
        v-model="selectedCourseInternalName"
        :options="courseInternalNameOptions"
        :clearable="true"
        :searchable="false"
        :loading="loadingInternal"
        :placeholder="$t('mc.mimk.mcReport.placeholder.donotChoise')"
        label="label"
        value="value"
        class="report__select"
        @input="handleCourseInternalNameChange"
      />
    </div>

    <div v-if="savedCourses.length > 0" class="report__choise">
      <label class="report__input-label">
        {{ $t('mc.mimk.mcReport.selectedCourses') || 'Выбранные курсы' }}:
      </label>
      <div class="selected-courses">
        <div
          v-for="course in savedCourses"
          :key="course.id"
          class="selected-course-chip"
        >
          {{ course.text }}
          <button
            @click="removeSavedCourse(course.id)"
            class="remove-course-btn"
          >
            ×
          </button>
        </div>
      </div>
    </div>

    <div v-if="selectedCourseInternalName" class="report__choise">
      <label class="report__input-label">
        {{ $t('mc.mimk.mcReport.course') || 'Курс' }}
      </label>
      <v-select
        v-model="selectedCourses"
        :options="courseOptions"
        :clearable="true"
        :searchable="false"
        :loading="loadingCourses"
        multiple
        :placeholder="$t('mc.mimk.mcReport.placeholder.donotChoise')"
        label="label"
        value="value"
        class="report__select"
        @input="handleCoursesChange"
      />
    </div>
  </div>
</template>

<script>
import { BACKOFFICE_V2 } from "@/services/HTTPService"

export default {
  name: 'CascadeCourseSelect',
  props: {
    businessBranchId: {
      type: Number,
      required: true
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedCourseGlobal: null,
      selectedCourseInternalName: null,
      selectedCourses: [],
      savedCourses: [],

      courseGlobalOptions: [],
      courseInternalNameOptions: [],
      courseOptions: [],

      loadingGlobal: false,
      loadingInternal: false,
      loadingCourses: false
    }
  },
  mounted() {
    this.fetchCourseGlobalList()
  },
  methods: {
    async fetchCourseGlobalList() {
      if (this.courseGlobalOptions.length > 0) return

      this.loadingGlobal = true
      try {
        const response = await BACKOFFICE_V2.get('/courses/get_course_global_list/')
        this.courseGlobalOptions = response.data.map(item => ({
          label: item.label,
          value: item.value
        }))
      } catch (error) {
        console.error('Ошибка при загрузке глобальных курсов:', error)
      } finally {
        this.loadingGlobal = false
      }
    },

    async fetchCourseInternalNames(courseGlobal) {
      if (!this.businessBranchId) return

      this.loadingInternal = true
      try {
        const response = await BACKOFFICE_V2.get(
          `/courses/get_course_internal_names/business_branch/${this.businessBranchId}/course_global/${courseGlobal}/`
        )
        this.courseInternalNameOptions = response.data.map(item => ({
          label: item,
          value: item
        }))
      } catch (error) {
        console.error('Ошибка при загрузке внутренних названий курсов:', error)
      } finally {
        this.loadingInternal = false
      }
    },

    async fetchCourses(courseGlobal, courseInternalName) {
      if (!this.businessBranchId) return

      this.loadingCourses = true
      try {
        const response = await BACKOFFICE_V2.get(
          `/courses/get_courses_by_internal_names_and_course_global/business_branch/${this.businessBranchId}/course_global/${courseGlobal}/internal_name/${courseInternalName}/`
        )
        this.courseOptions = (response.data.results || response.data).map(course => ({
          label: course.title,
          value: course.id,
          ...course
        }))
      } catch (error) {
        console.error('Ошибка при загрузке курсов:', error)
      } finally {
        this.loadingCourses = false
      }
    },

    handleCourseGlobalChange(value) {
      this.selectedCourseGlobal = value
      this.selectedCourseInternalName = null
      this.selectedCourses = []

      this.courseInternalNameOptions = []
      this.courseOptions = []

      if (value) {
        this.fetchCourseInternalNames(value.value)
      }

      this.emitChange()
    },

    handleCourseInternalNameChange(value) {
      this.selectedCourseInternalName = value
      this.selectedCourses = []

      this.courseOptions = []

      if (value && this.selectedCourseGlobal) {
        this.fetchCourses(this.selectedCourseGlobal.value, value.value)
      }

      this.emitChange()
    },

    handleCoursesChange(value) {
      this.selectedCourses = value || []

      if (value && value.length > 0) {
        const coursesWithText = value.map(course => ({
          id: course.value || course.id,
          text: course.label || course.title || course.text,
        }))

        const newCourses = coursesWithText.filter(course =>
          !this.savedCourses.some(saved => saved.id === course.id)
        )

        this.savedCourses = [...this.savedCourses, ...newCourses]
      }

      this.emitChange()
    },

    removeSavedCourse(courseId) {
      this.savedCourses = this.savedCourses.filter(course => course.id !== courseId)
      this.emitChange()
    },

    emitChange() {
      this.$emit('update:modelValue', this.savedCourses)
    },

    resetAll() {
      this.selectedCourseGlobal = null
      this.selectedCourseInternalName = null
      this.selectedCourses = []
      this.courseInternalNameOptions = []
      this.courseOptions = []
      this.emitChange()
    }
  },

  watch: {
    businessBranchId: {
      handler(newValue) {
        if (newValue) {
          this.resetAll()
          this.fetchCourseGlobalList()
        }
      },
      immediate: true
    },

    modelValue: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.savedCourses = [...newValue]
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.cascade-course-select {
  width: 100%;
}

.selected-courses {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.selected-course-chip {
  display: inline-flex;
  align-items: center;
  background: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 12px;
  color: #1976d2;
}

.remove-course-btn {
  background: none;
  border: none;
  color: #1976d2;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  margin-left: 8px;
  padding: 0;
  line-height: 1;

  &:hover {
    color: #d32f2f;
  }
}
</style>
